import React, {Component} from 'react';

import moneyBackImg from "../../assets/images/svg/05.svg";
import profitImg from "../../assets/images/svg/01.svg";
import profitImgDone from "../../assets/images/svg/04.svg";
import marketRateImg from "../../assets/images/svg/06.svg";
import profitYearImg from "../../assets/images/svg/02.svg";
import costYearImg from "../../assets/images/svg/03.svg";



import StudyResultsBox from './study-results-box';

class StudyResults extends Component{

    componentDidMount() {
        
      }
      
    render(){
        return(
            
        <div className="study-results">
            <div className="container">
                <div className="st-wrapper">
                        <div className="section-intro wow fadeInRight">
                            <h3 className="section-title">نتائج الدراسة</h3>
                            <p className="section-info">عند الانتهاء سوف تحصل على تقرير تفصيلى يتضمن</p>
                        </div>
                        <div className="st-results">
                            <div className="st-result-group wow fadeInDown" data-wow-delay="0.5s">
                                <StudyResultsBox boxImage={moneyBackImg}  boxTitle1={"فترة إسترداد"} boxTitle2={"رأس المال"}/>
                                <StudyResultsBox boxImage={profitImg}  boxTitle1={"أدنى سعر"} boxTitle2={"للربحية"}/>
                                <StudyResultsBox boxImage={profitImgDone}  boxTitle1={" الهامش"} boxTitle2={"الربحى"}/>
                            </div>
                            <div className="st-result-group wow fadeInUp" data-wow-delay="0.5s">
                                  <StudyResultsBox boxImage={marketRateImg}  boxTitle1={"معدل الحصة"} boxTitle2={"السوقية"}/>
                                  <StudyResultsBox boxImage={profitYearImg}  boxTitle1={"الأربـــاح"} boxTitle2={"السنوية والشهرية"}/>
                                  <StudyResultsBox boxImage={costYearImg}  boxTitle1={"التكاليف"} boxTitle2={"السنوية والشهرية"}/>
                            </div>
                        </div>
                </div>
            </div>   
        </div>
        )
    }

};
export default StudyResults;
